import React from 'react';
import { RouteObject } from 'react-router-dom';
import { LayoutComponent } from 'components';
import { userApp } from './userApp';
import { eventApp } from './eventApp';
import { platformApp, platformFullPageApp } from './platformApp';
import { noticeApp } from './noticeApp';
import { pushApp } from './pushApp';
import { accountsApp } from './accountsApp';

export const privateApp: RouteObject = {
  element: <LayoutComponent.Private />,
  children: [
    ...platformFullPageApp,
    {
      element: <LayoutComponent.Main />,
      children: [
        ...userApp,
        ...eventApp,
        ...platformApp,
        ...noticeApp,
        ...pushApp,
        ...accountsApp,
        {
          path: '/',
          element: (
            <>
              <h1 css={{ marginTop: '24px' }}>Home</h1>
            </>
          ),
        },
        {
          path: '*',
          element: (
            <>
              <h1 css={{ marginTop: '24px' }}>페이지를 찾을 수 없습니다.</h1>
            </>
          ),
        },
      ],
    },
  ],
};
